import React from "react";
import "./LeibnizButton.css";
import banner from "../images/banner3.jpg"; // adjust path if needed

const LeibnizButton = ({ link = "/" }) => {
  return (
    <a href={link} className="leibniz-button">
      <div
        className="leibniz-bg"
        style={{ backgroundImage: `url(${banner})` }}
      />
      <div className="leibniz-overlay" />
      <div className="leibniz-content">
  <span className="btn-text">Explore the New Edition</span>
      </div>
      <div className="gold-border" />
    </a>
  );
};

export default LeibnizButton;